<template>
  <div style="height:92%">
    <split-pane :defaultPercent="25">
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-panel-y mw-panel__tree">
            <div class="mw-toolbar">
              <h5>流程干预</h5>
            </div>
            <div
              class="mw-toolbar__body mw-app__edit"
              style="padding:10px 20px 0px 0px;"
            >
              <el-form
                :model="filterForm"
                label-width="80px"
                size="mini"
                @submit.native.prevent="updateTable"
                :rules="rules"
                ref="filterFormRef"
              >
                <el-form-item label="流程状态">
                  <el-select
                    :clearable="false"
                    v-model="filterForm.flowStatus"
                    placeholder=""
                    style="width:100%;"
                  >
                    <el-option
                      label="全部"
                      value=""
                    />
                    <el-option
                      label="正在办理"
                      value="0"
                    />
                    <el-option
                      label="已办结"
                      value="1"
                    />
                    <el-option
                      label="已挂起"
                      value="2"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item label="年度">
                  <el-date-picker
                    v-model="filterForm.year"
                    type="year"
                    format="yyyy"
                    value-format="yyyy"
                    placeholder=""
                    style="width:100%;"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="流程">
                  <FlowSelect v-model="filterForm.processDefinition" />
                </el-form-item>

                <el-form-item label="单位">
                  <UnitSelect v-model="filterForm.draftsUnit" />
                  <el-checkbox v-model="filterForm.matchDept">匹配部门</el-checkbox>
                </el-form-item>

                <el-form-item
                  label="标题"
                  prop="businessName"
                >
                  <el-input
                    type="textarea"
                    autosize
                    placeholder=""
                    :clearable="true"
                    style="border-radius:0;border-bottom: 10px solid transparent;"
                    v-model="filterForm.businessName"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="业务ID"
                  prop="businessId"
                >
                  <el-input
                    type="textarea"
                    autosize
                    placeholder=""
                    :clearable="true"
                    style="border-radius:0;border-bottom: 10px solid transparent;"
                    v-model="filterForm.businessId"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="筛选条件">
                  <el-tag
                    v-for="item in filterQuery"
                    :key="item.source"
                    @close="handleRemoveQuery(item)"
                    size="mini"
                    style="margin:5px;"
                    closable
                  >
                    {{item.value}}
                  </el-tag>
                </el-form-item>

                <el-form-item label="">
                  <el-button
                    style="width:100%"
                    type="primary"
                    native-type="submit"
                  >查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <mwFlowInterferingTable :filterParams="filterParams" ></mwFlowInterferingTable>
      </template>
    </split-pane>
  </div>
</template>
<script>
  import mwFlowInterferingTable from "./rightPanel.vue";
  import FlowSelect from "./common/flowSelect";
  import UnitSelect from "./common/unitSelect";
export default {
  data() {
    return {
      filterForm: {
        flowStatus: "",
        suspensionState: "",
        year: "" + new Date().getFullYear(),
        processDefinition: {},
        draftsUnit: {},
        matchDept: false,
        businessName: ""
      },
      filterParams:{

      },
      dataList: [],

      pagination: {
        total: 0,
        start: 0,
        limit: 10
      },

      orderBy: "",

      selection: [],

      rules: {
        // businessName: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (!value) {
        //         callback(new Error("请填写标题"));
        //         return;
        //       }
        //       if (!value.trim()) {
        //         callback(new Error("请填写标题"));
        //         return;
        //       }
        //       callback();
        //     },
        //     trigger: "input"
        //   }
        // ]
      }
    };
  },

  mounted() {},

  computed: {
    filterQuery() {
      const query = [];
      if (this.filterForm.flowStatus) {
        query.push({
          source: "flowStatus",
          value: ["正在办理", "已办结", "已挂起"][this.filterForm.flowStatus]
        });
      }

      if (this.filterForm.year) {
        query.push({
          source: "year",
          value: this.filterForm.year
        });
      }

      if (
        this.filterForm.processDefinition &&
        this.filterForm.processDefinition.name
      ) {
        query.push({
          source: "processDefinition",
          value: this.filterForm.processDefinition.name
        });
      }

      if (this.filterForm.draftsUnit && this.filterForm.draftsUnit.name) {
        query.push({
          source: "draftsUnit",
          value: this.filterForm.draftsUnit.name
        });
      }

      if (this.filterForm.businessName) {
        query.push({
          source: "businessName",
          value: this.filterForm.businessName
        });
      }
      if (this.filterForm.businessId) {
        query.push({
          source: "businessId",
          value: this.filterForm.businessId
        });
      }
      return query;
    }
  },

  methods: {
    handleRemoveQuery({ source }) {
      let emptyValue = "";
      switch (source) {
        case "processDefinition":
        case "draftsUnit": {
          emptyValue = {};
          break;
        }
        default: {
          emptyValue = "";
        }
      }
      this.filterForm = { ...this.filterForm, [source]: emptyValue };
    },
    updateTable(){
      if (!this.filterForm.businessName && !this.filterForm.businessId) {
        this.mwMsg("warning", "标题或业务ID不能为空!");
        return;
      }
      let params = {}
      _.assign(params,this.filterForm);
      this.filterParams = params;
    }
  },
  components: {
    FlowSelect,
    UnitSelect,
    mwFlowInterferingTable
  }
};
</script>

<style>
.el-textarea__inner {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/index.vue